// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NPqX","footer":"styles_footer__-UiiX"};